var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpBooksApiV5Request } from "./http-api-request.js";
export function createTransaction(bookId, transaction, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/transactions`, config).setMethod('POST').setPayload(transaction).fetch();
        return response.data;
    });
}
export function postTransactionsBatch(bookId, transactions, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const payload = { items: transactions };
        yield new HttpBooksApiV5Request(`${bookId}/transactions/post/batch`, config).setMethod('PATCH').setPayload(payload).fetch();
    });
}
export function createTransactionsBatch(bookId, transactions, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let transactionList = { items: transactions };
        const payload = transactionList;
        const response = yield new HttpBooksApiV5Request(`${bookId}/transactions/batch`, config).setMethod('POST').setPayload(payload).fetch();
        transactionList = yield response.data;
        return transactionList != null && transactionList.items != null ? transactionList.items : [];
    });
}
export function updateTransactionsBatch(bookId, transactions, updateChecked, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let transactionList = { items: transactions };
        const payload = transactionList;
        const response = yield new HttpBooksApiV5Request(`${bookId}/transactions/batch`, config).setMethod('PUT').setPayload(payload).addParam('updateChecked', updateChecked).fetch();
        transactionList = yield response.data;
        return transactionList != null && transactionList.items != null ? transactionList.items : [];
    });
}
export function checkTransactionsBatch(bookId, transactions, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const payload = { items: transactions };
        yield new HttpBooksApiV5Request(`${bookId}/transactions/check/batch`, config).setMethod('PATCH').setPayload(payload).fetch();
    });
}
export function uncheckTransactionsBatch(bookId, transactions, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const payload = { items: transactions };
        yield new HttpBooksApiV5Request(`${bookId}/transactions/uncheck/batch`, config).setMethod('PATCH').setPayload(payload).fetch();
    });
}
export function trashTransactionsBatch(bookId, transactions, trashChecked, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let transactionList = { items: transactions };
        const payload = transactionList;
        const response = yield new HttpBooksApiV5Request(`${bookId}/transactions/trash/batch`, config).setMethod('PATCH').setPayload(payload).addParam('trashChecked', trashChecked).fetch();
        transactionList = yield response.data;
    });
}
export function untrashTransactionsBatch(bookId, transactions, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let transactionList = { items: transactions };
        const payload = transactionList;
        const response = yield new HttpBooksApiV5Request(`${bookId}/transactions/untrash/batch`, config).setMethod('PATCH').setPayload(payload).fetch();
        transactionList = yield response.data;
    });
}
export function updateTransaction(bookId, transaction, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/transactions`, config).setMethod('PUT').setPayload(transaction).fetch();
        return response.data;
    });
}
export function postTransaction(bookId, transaction, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/transactions/post`, config).setMethod('PATCH').setPayload(transaction).fetch();
        return response.data;
    });
}
export function checkTransaction(bookId, transaction, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/transactions/check`, config).setMethod('PATCH').setPayload(transaction).fetch();
        return response.data;
    });
}
export function uncheckTransaction(bookId, transaction, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/transactions/uncheck`, config).setMethod('PATCH').setPayload(transaction).fetch();
        return response.data;
    });
}
export function trashTransaction(bookId, transaction, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/transactions/trash`, config).setMethod('PATCH').setPayload(transaction).fetch();
        return response.data;
    });
}
export function restoreTransaction(bookId, transaction, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/transactions/restore`, config).setMethod('PATCH').setPayload(transaction).fetch();
        return response.data;
    });
}
export function getTransaction(bookId, id, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/transactions/${id}`, config).setMethod('GET').fetch();
        return response.data;
    });
}
export function getTransactionsByIds(bookId, ids, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const payload = {
            items: ids.map(id => ({ id: id })),
        };
        const response = yield new HttpBooksApiV5Request(`${bookId}/transactions/load`, config)
            .setMethod('POST')
            .setPayload(payload)
            .fetch();
        const transactionList = response.data;
        return transactionList != null && transactionList.items != null ? transactionList.items : [];
    });
}
export function listTransactions(bookId, query, limit, cursor, config) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!query) {
            query = "";
        }
        if (!limit) {
            limit = 100;
        }
        var request = new HttpBooksApiV5Request(`${bookId}/transactions`, config);
        request.addParam('query', query);
        request.addParam('limit', limit);
        if (cursor != null) {
            request.setHeader('cursor', cursor);
        }
        var response = yield request.fetch();
        return response.data;
    });
}
export function mergeTransactions(bookId, transactions, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const payload = Object.assign({}, transactions);
        const response = yield new HttpBooksApiV5Request(`${bookId}/transactions/merge`, config).setMethod('PATCH').setPayload(payload).fetch();
        return response.data;
    });
}
export function countTransactions(bookId, query, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const request = new HttpBooksApiV5Request(`${bookId}/transactions/count`, config).setMethod('GET').addParam('query', query);
        const response = yield request.fetch();
        return response.data;
    });
}
//# sourceMappingURL=transaction-service.js.map